export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/fundorex-crowdfunding-platform`;
export const COLOR = '#F97316';
export const LIGHT_COLOR = '#FFF7ED';
export const PURCHASE_URL = 'https://codecanyon.net/item/fundorex-crowdfunding-platform/33286096';
export const DEMO_URL = 'https://fundorex.xgenious.com';
export const ADMIN_URL = 'https://fundorex.xgenious.com/admin';
export const DOCS_URL = 'https://docs.xgenious.com/docs/fundorex/';
export const PLUGIN_DEV_DOCS_URL = 'https://docs.xgenious.com/docs/fundorex/plugin-development/scaffold-manifest/';
export const CHANGELOG_URL = 'https://docs.xgenious.com/docs/fundorex/instructions/changes-logs/';
export const REFUND_POLICY_URL = '/refund-policy';
export const ENVATO_REFUND_POLICY_URL = 'https://codecanyon.net/page/customer_refund_policy';
export const REGULAR_PRICE = 69;
export const COMBO_PRICE = 79;
export const EXTENDED_PRICE = 199;

export const PLAY_URL = 'https://play.google.com/store/apps/details?id=com.xgenious.funderox';

export const QUICK_LINKS = [
  { label: 'Admin Panel', href: ADMIN_URL },
  { label: 'Mobile App', href: '#mobile-app' },
  { label: 'Documentation', href: DOCS_URL },
  { label: 'Pricing', href: '#pricing' },
];

export const STATS = [
  { value: '734+', label: 'Active sales' },
  { value: '4.70/5', label: 'CodeCanyon rating' },
  { value: '43', label: 'Verified reviews' },
  { value: '1-time', label: 'Purchase' },
];

export const TECH = [
  { name: 'Laravel', desc: 'PHP 8+ backend framework' },
  { name: 'Bootstrap 4', desc: 'Responsive UI components' },
  { name: 'MySQL', desc: 'Relational database' },
  { name: 'jQuery', desc: 'Dynamic frontend interactions' },
  { name: 'Flutter', desc: 'Cross-platform mobile app' },
  { name: 'Stripe & PayPal', desc: 'Secure payment processing' },
];

export const FEATURES: { title: string; desc: string; img?: string }[] = [
  {
    title: 'Accept Donations for Any Cause',
    desc: 'Campaign owners launch fundraisers with a goal, deadline, and media gallery. Donors see real-time progress and give in seconds — no friction, no confusion.',
    img: '/products/fundorex-feature-1.jpg',
  },
  {
    title: 'Sell Event Tickets Alongside Campaigns',
    desc: 'Host fundraising events and sell tickets directly through your platform. Combine event revenue with campaign donations — all managed from one admin dashboard.',
    img: '/products/fundorex-feature-2.jpg',
  },
  {
    title: 'Keep More of Every Donation',
    desc: 'Set your platform fee as a percentage or flat amount per campaign. Transparent to donors before they give, and configurable in minutes — no code required.',
    img: '/products/fundorex-charge-breakdown.png',
  },
  {
    title: 'Highlight Urgent Campaigns Instantly',
    desc: 'Mark any campaign as an emergency funding need. It appears prominently across the platform to drive faster donations when every hour counts.',
    img: '/products/fundorex-feature-4.jpg',
  },
  {
    title: 'Flexible Fee Collection — Your Rules',
    desc: 'Charge the donor, the campaign owner, or split the fee. Choose percentage or fixed amount per transaction — all configurable from the admin panel.',
    img: '/products/fundorex-feature-5.png',
  },
  {
    title: 'Let Anyone Launch a Campaign',
    desc: 'Registered users submit campaigns for your approval before they go live. You stay in full control of what gets published on your platform.',
    img: '/products/fundorex-feature-7.jpg',
  },
  {
    title: 'Built-In Help Desk for Your Platform',
    desc: 'Users raise support tickets directly from the platform. Manage, reply, and resolve tickets from your admin dashboard — no third-party helpdesk needed.',
    img: '/products/fundorex-feature-8.jpg',
  },
  {
    title: 'Donors Share Campaigns in One Click',
    desc: 'Built-in sharing to all major social platforms, plus QR code and direct email — so campaigns spread organically and reach more donors without extra tools.',
    img: '/products/fundorex-feature-6.jpg',
  },
  {
    title: 'Medical Emergency Campaigns',
    desc: 'Campaign owners flag a fundraiser as a medical emergency — it gets a prominent badge and priority placement across the platform to drive faster donations when lives are at stake.',
    img: '/products/fundorex-feature-emergency.png',
  },
  {
    title: 'Campaigns Auto-Close at Deadline',
    desc: 'Set a deadline and the platform automatically closes the campaign when the date arrives or the goal is met — no manual action needed from you or the campaign owner.',
    img: '/products/fundorex-feature-deadline.png',
  },
  {
    title: 'Campaign Updates & Donor Comments',
    desc: 'Campaign owners post progress updates to keep donors informed. Donors leave comments and ask questions directly on the campaign page — building transparency and trust.',
    img: '/products/fundorex-feature-campaign-updates.png',
  },
  {
    title: 'Image Gallery & Video Support',
    desc: 'Campaign owners upload multiple images and embed videos to tell their story compellingly. Rich media gives donors the confidence to contribute to legitimate causes.',
    img: '/products/fundorex-feature-gallery.png',
  },
  {
    title: 'Keep Donors Coming Back',
    desc: 'Built-in newsletter module to announce new campaigns, share updates, and drive repeat donations — without connecting any external email marketing tool.',
    img: '/products/fundorex-feature-10.jpg',
  },
  {
    title: 'Remove Signup Friction with Social Login',
    desc: 'Donors and campaign creators sign up instantly with Facebook or Google — reducing drop-off and increasing first-time contributor conversions from day one.',
    img: '/products/fundorex-feature-11.jpg',
  },
  {
    title: 'Generate Tax Redemption Certificates',
    desc: 'Donors automatically receive a downloadable tax exemption certificate after each donation — increasing trust and encouraging larger contributions from corporate and high-value donors.',
    img: '/products/fundorex-feature-tax.png',
  },
  {
    title: 'Recurring Monthly Donations',
    desc: 'Donors set up automatic monthly contributions to any campaign. Predictable recurring revenue helps campaigns reach their goals and keeps donors engaged long-term.',
    img: '/products/fundorex-feature-recurring.png',
  },
  {
    title: 'Collaborative Community Campaigns',
    desc: 'Multiple users collaborate on a shared fundraising goal. Campaign owners invite volunteers, assign roles, and track contributions from every community member.',
    img: '/products/fundorex-feature-community.png',
  },
  {
    title: 'Report Suspicious Campaigns',
    desc: 'Donors can flag any campaign directly from the campaign page. Admins receive the report and can review, pause, or remove the campaign — keeping your platform trustworthy.',
    img: '/products/fundorex-feature-report.png',
  },
  {
    title: 'Donor Reward System',
    desc: 'Donors earn rewards and recognition for contributing to campaigns. Campaign owners define reward tiers — motivating higher contributions and repeat donations.',
    img: '/products/fundorex-feature-reward.png',
  },
  {
    title: 'Campaign Success Stories',
    desc: 'Completed campaigns can publish a success story showing the real-world impact of donations. Visible to all visitors — building credibility and encouraging future donors.',
    img: '/products/fundorex-feature-success-story.png',
  },
];

export const CHANGELOG: { version: string; date: string; summary: string }[] = [
  { version: 'Latest', date: 'September 15, 2026', summary: 'The plugin framework goes production-ready (discovery, enable/disable/uninstall, menus, assets, migrations, audit log). The new Fundraising plugin (Kickstarter-style crowdfunding) and AI Multilingual plugin (AI-assisted translation) both become feature-complete.' },
  { version: '2.1.0', date: 'June 24, 2026', summary: 'Admin campaign preview for draft/archived/banned campaigns, emergency causes page-builder widget, PDF invoice redesign, and the Xendit payment gateway.' },
  { version: '2.0.2', date: 'June 4, 2026', summary: 'reCAPTCHA v2/v3 selector, donor name/email fields on donation logs, and compact K/M/B amount formatting.' },
  { version: '2.0.0', date: 'May 19, 2026', summary: 'Major overhaul — brand-new admin panel and frontend rebuilt with Tailwind CSS, plus a visual drag-and-drop page builder.' },
  { version: '1.7.0', date: 'July 31, 2025', summary: 'Upgraded the core to Laravel 12.' },
];

export const REVIEWS: { name: string; category: string; rating: number; body: string; source?: string }[] = [
  {
    name: 'nkingsly',
    category: 'Customer Support',
    rating: 5,
    body: 'Outstanding support from the Xgenious team. They are responsive, proactive, and genuinely go above and beyond to resolve issues. The product itself is excellent — everything works as described.',
  },
  {
    name: 'Ashok Krish',
    category: 'Customer Support',
    rating: 5,
    source: 'Trustpilot',
    body: 'Using their Fundorex product of Xgenious and they were good in customer support of their products whenever I have faced issues.',
  },
  {
    name: 'caribman',
    category: 'Update Support',
    rating: 5,
    source: 'Trustpilot',
    body: "I couldn't load my page after I updated to Fundorex v1.1.5, and Xgenious with their excellent service resolved the problem.",
  },
  {
    name: 'tuliog',
    category: 'Design Quality',
    rating: 5,
    body: "There's no better crowdfunding theme than Fundorex. Excellent customer service — always there to help. Very professional team and a beautiful, well-built product.",
  },
  {
    name: 'Claudivam',
    category: 'Customer Support',
    rating: 5,
    body: 'Perfect script and clean code. The platform delivers exactly what was described and the support team is very fast and helpful. Highly recommended.',
  },
  {
    name: 'Crazetech',
    category: 'Code Quality',
    rating: 5,
    body: 'Clean code, easy install, no issues out of the box, and very easy to use. Will definitely be buying more products from this author.',
  },
  {
    name: 'hopitalFuuta',
    category: 'Customer Support',
    rating: 5,
    body: 'Very professional! My problem was resolved in less than half an hour. This is my second license — that says everything about the quality of this product and team.',
  },
  {
    name: 'THE-GREAT-GATSBY',
    category: 'Feature Availability',
    rating: 5,
    body: 'The Fundorex team provides genuine assistance with updates and goes out of their way to help. Highly recommend this script for anyone building a crowdfunding platform.',
  },
  {
    name: 'pathanubaid',
    category: 'Flexibility',
    rating: 5,
    body: 'Awesome product and great support. Thank you for the prompt response and your help — issues were resolved quickly and professionally.',
  },
  {
    name: 'straincogroup',
    category: 'Customer Support',
    rating: 5,
    body: 'Outstanding customer service and great support. The team is always available and makes sure every issue is resolved before closing the ticket.',
  },
  {
    name: 'tlarose1963',
    category: 'Customer Support',
    rating: 5,
    body: 'Top notch service. Prompt replies, clear instructions, and a product that works exactly as advertised. Very happy with this purchase.',
  },
  {
    name: 'tienld',
    category: 'Customer Support',
    rating: 5,
    body: 'Strong support! Thank you to the whole team. Every question I had was answered quickly and thoroughly. Great experience from start to finish.',
  },
  {
    name: 'envato1905',
    category: 'Customer Support',
    rating: 5,
    body: 'Good product and solid desk support. Issues were handled efficiently and the team was polite and knowledgeable throughout the process.',
  },
  {
    name: 'mdb15',
    category: 'Documentation Quality',
    rating: 4,
    body: 'Project works fine. Had a PHP version installation issue but the support team helped resolve it. Documentation could be expanded but overall a solid product.',
  },
];
